/**
 * Ownership of a note, highlight or flashcard.
 *
 * The host attaches an `author` block only to entries written by somebody else, so its
 * presence is the ownership answer. The color is not: highlighter slugs come from the
 * label and are deduplicated only against the reader's own palette, so a slug another
 * author shares can equally name a highlighter of the reader's own.
 */

/**
 * Whether the annotation was written by another reader, which makes it read-only here.
 * @param {{author?: Object}} annotation - A note, highlight or flashcard
 * @returns {boolean}
 */
export function isAnnotationFromAnotherReader(annotation) {
    return Boolean(annotation?.author);
}
